import { createContext, useContext, useState } from "react";

const FiltrosContext = createContext();

export const FiltrosProvider = ({ children }) => {
    const [columnFilters, setColumnFilters] = useState([]);

    return (
        <FiltrosContext.Provider value={{ columnFilters, setColumnFilters }}>
            {children}
        </FiltrosContext.Provider>
    );
};

export const useFiltros = () => useContext(FiltrosContext);

{/*
    COMPONENTE PARA GUARDAR EL FILTRO DE LA COLUMNA: 
     ¿Cómo funciona? 
        <Route
                  path="/autorizacion_compras"
                  element={
                    <FiltrosProvider>
                      <Private Component={TabAutorizaciones} />
                    </FiltrosProvider>
                  }
                />

                Se va a encerrar el componente en la etiqueta FiltrosProvider

    Este componente usa useContext que es un hook de React
    En el componente  
    import { useFiltros } from './context/FiltrosContext';

    const { columnFilters, setColumnFilters } = useFiltros();
  const [showColumnFilters, setShowColumnFilters] = useState(true);

  y dentro del Material-React-Table
   <MaterialReactTable
                
                state={{ columnFilters, showColumnFilters }}
                  onColumnFiltersChange={setColumnFilters} // todas las tablas comparten este estado
                 
                  initialState={initialState}
                 //otras propiedades
    
    
    
    
    
    
    */}